var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoundationIconsVehiclesCarCarMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "q2877v41za",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#q2877v41za)",
    transform: "translate(-278.000000, -642.000000) translate(210.000000, 112.000000) translate(40.000000, 126.000000) translate(0.000000, 154.000000) translate(4.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.467,
    transform: "translate(24.000000, 16.000000) translate(1.000000, 7.500000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.133,
    cy: 10.5,
    rx: 1.467,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.4,
    cy: 10.5,
    rx: 1.467,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 10.5L5.867 10.5M2.933 10.5H1.467C.657 10.5 0 9.828 0 9V7.5c0-1.657 1.313-3 2.933-3L4.728.829C4.976.321 5.484-.001 6.04 0h7.724c.556 0 1.064.32 1.312.829l1.79 3.671h2.2c1.62 0 2.934 1.343 2.934 3V9c0 .828-.657 1.5-1.467 1.5H17.6M16.867 4.5L2.933 4.5"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationIconsVehiclesCarCarMd);
export default __webpack_public_path__ + "static/media/foundation-icons-vehicles-car-car-md.33a6834ea61b13dd23f8362016410f40.svg";
export { ForwardRef as ReactComponent };